<template>
    <div class="container" id="app">
      <router-view v-if="isTracking"/>
      <div v-else>
        <static-header/>
        <div class="col-lg-10 float-left">
          <static-header-mobile/>
        </div>
        <div class="col-lg-2 float-left d-lg-block d-none" id="nav-side">
          <nav-side/>
        </div>
        <div class="col-lg-10 float-left">
          <router-view/>
        </div>
        <div class="col-lg-12 float-left">
          <static-footer/>
        </div>
      </div>
    </div>
</template>

<script>
import NavSide from './components/Menu/NavSide'
import StaticHeader from './components/Static/Header'
import StaticHeaderMobile from './components/Static/HeaderMobile'
import StaticFooter from './components/Static/Footer'
import Hotjar from '@hotjar/browser'

export default {
  name: 'app',
  components: {
    NavSide,
    StaticHeader,
    StaticHeaderMobile,
    StaticFooter
  },

  data () {
    return {
      isTracking: this.$route.path === '/tracking'
    }
  },

  created () {
    const siteId = process.env.VUE_APP_HOTJAR_SITE_ID
    const hotjarVersion = process.env.VUE_APP_HOTJAR_VERSION
    Hotjar.init(siteId, hotjarVersion)
  }
}
</script>
